import { MINUTE_IN_MS } from '@shared/constants';

export const LIMIT_PER_PAGE = 10;
export const LIMIT_TO_WATCH_AUTHORIZED = 15;
export const LIMIT_TO_WATCH_NON_AUTHORIZED = 10;
export const ITEM_LEFT_THRESHOLD = 3;
export const FEED_BLOCKING_TIME = 5 * MINUTE_IN_MS;
